module.exports = __webpack_public_path__ + "static/media/menu9-active.b97bf331.png";